import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { forHumans } from "@madmedical/medical";
import { Dimensions } from "react-native";
import { isWeb } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import PressableLink from "../../atoms/PressableLink";
import GraphThumbnail from "../GraphThumbnail";
import { ChartWidget } from "./model";
const screenWidth = Dimensions.get("window").width;
const getGraphSize = (widget, graphWidth) => {
    switch (widget) {
        case ChartWidget.DashboardSingle:
            return isWeb
                ? { x: graphWidth !== null && graphWidth !== void 0 ? graphWidth : 160, y: 120 }
                : {
                    x: graphWidth !== null && graphWidth !== void 0 ? graphWidth : screenWidth / 2.8,
                    y: screenWidth / 2.8 / 2,
                };
        case ChartWidget.DashboardTwoByTwo:
            return isWeb
                ? { x: graphWidth !== null && graphWidth !== void 0 ? graphWidth : 320, y: 240 }
                : {
                    x: graphWidth !== null && graphWidth !== void 0 ? graphWidth : screenWidth / 2.8,
                    y: screenWidth / 2.8 / 2,
                };
    }
};
const GraphThumbnailWrapper = ({ metricType, widget, displayLast, graphProps, }) => {
    // TODO: Dashboard widget should probably be responsive too. See GraphWrapper.tsx
    const [graphWidth] = useState();
    const { t } = useTranslation();
    const resolvedProps = useMemo(() => (Object.assign(Object.assign({}, graphProps), { slot: getGraphSize(widget, graphWidth), paddingPercents: { x: 2, y: 2 }, dashboardThumbnail: {
            title: t(`measures:${forHumans(metricType)}`),
            isDashboardThumbnail: true,
            showLineGraphNodes: true,
            valueToDisplay: displayLast,
        } })), [graphProps, widget, graphWidth, t, metricType, displayLast]);
    return (_jsx(PressableLink, Object.assign({ route: "measurements", params: { metricType } }, { children: _jsx(GraphThumbnail, { graphProps: resolvedProps }) })));
};
export default GraphThumbnailWrapper;
